import React from 'react';
import PropTypes from 'prop-types';
import { UiButton } from 'ui-components';
import _ from 'lodash';

/**
 * اکشن نمایش یک رکورد
 * @param {*Object} action آبجکت اکشن
 * @param {*Number} itemId شناسه رکورد
 */
const UiActionView = ({ action, item }) => {
  return (
    <UiButton
      type='icon'
      onClick={() => action.onClick(item)}
      className={`icon ${action.icon}`}
      size='xxs'
      tooltip={action.tooltip}
      disabled={
        _.isFunction(action.disabled) ? action.disabled(item) : action.disabled
      }
    />
  );
};
UiActionView.propTypes = {
  action: PropTypes.object,
  itemId: PropTypes.number,
  item: PropTypes.object,
};

export default UiActionView;
